module.exports = __webpack_public_path__ + "img/favicon.67131b97.png";